module.exports = __webpack_public_path__ + "img/group-sending-function.2e55e982.png";